import React, { useState } from 'react';
import ButtonFileUpload from '../../molecules/ButtonFileUpload/ButtonFileUpload';

interface PostalCodeFormProps {
  onChange: (file: string) => void;
}

const PostalCodeForm = ({ onChange }: PostalCodeFormProps) => {
  const [file, setFile] = useState<string | File | null>();
  const isFileEmpty = file === '';
  return (
    <div className={'flex gap-3 items-center'}>
      <ButtonFileUpload accept=".xlsx"
                        label={'Cargar archivo'}
                        base64
                        onSubmit={(e) => {
                          setFile(e);
                          if (typeof e === 'string') {
                            onChange(e);
                          }
                        }} />
      {isFileEmpty && <div className="text-xs mt-1.5">
        <span>
          <a
            className="text-blue-600"
            href={require('../../../assets/zip_code_template.xlsx')}
            download={'zip_code_template.xlsx'}
          >
                Descargar plantilla
            </a>
        </span>
      </div>}
    </div>
  );
};

export default PostalCodeForm;
